export default {
  namespaced: true,
  state: {
    noticeList: [
      {
        id: '24',
        type: 'info',
        name: 'おかずかんスピンオフノベルゲームのアップデートについて',
        date: '2021/11/01',
        detail:
          '現在配信中のおかずかんスピンオフノベルゲーム、\n『きざみのりみち ナンバーワンホストの道』、『ラーゆせんぱい恋物語』の機能追加と軽微な不具合の修正を行いました。\nバージョンアップにて追加した機能は以下のとおりです。\n\n---------------------------------------\n■追加機能\n①『ラーゆせんぱい恋物語』へのリンクを追加\n『きざみのりみち ナンバーワンホストの道』のメニュー内の関連ゲームに、『ラーゆせんぱい恋物語』のリンクを追加しました。\nこちらもぜひダウンロードして遊んでみてください♪\n\n②動画広告再生の回数制限を無制限に変更\n1日3回までとしていた動画広告の再生回数の上限をなくし、無制限にいたしました。\n\n③チュートリアル後の動作変更\nチュートリアル終了後、ストーリーボタンがわかりやすくなるようストーリーボタンをハイライト表示するようにいたしました。\n\n④未選択の選択肢を明瞭化\nストーリー選択画面内にて、未選択の選択肢があるストーリーは「未選択あり」と表記されます。\nまた、ストーリー進行中に表示される選択肢は一度選択したものは文字がグレーになるように変更いたしました。',
      },
      {
        id: '23',
        type: 'release',
        name: 'おかずかんのスピンオフノベルゲーム第2弾がリリース！',
        date: '2021/07/14',
        detail:
          '7月14日(水)より、おかずかん短編ノベルゲーム第2弾『ラーゆせんぱい 恋物語』をリリースしました！\n---------------------------------------\n『ラーゆせんぱい 恋物語』は、選択肢を選ぶと物語が進んでいく選択式ノベルゲームです。\n『おかずかん』に登場する、「ラーゆせんぱい」「ごまドレさん」「ホイップん」が繰り広げるちょっとおかしな恋物語となっています♪\n\n突っ走りがちな熱血漢、ラーゆせんぱいがある日ひとりの女の子にひとめぼれ。\n彼女ともっと仲良くなりたい・・・そんな想いを察知してホイップんが恋のお手伝いにやってきます！\n果たしてラーゆせんぱいの想いは伝わるのでしょうか・・・？\n\n新規描き下ろしのイラストで、よりコミカルになったキャラクター達がストーリーを盛り上げます♪\nぜひインストールしてプレイしてみてください！',
      },
      {
        id: '22',
        type: 'info',
        name: '夏の期間限定料理を追加しました！',
        date: '2021/06/01',
        detail:
          '6月1日より『夏の季節限定料理』が新しく追加されました！\n今回入手できる夏の季節料理は、\n「うな重」「冷やし中華」「ゴーヤチャンプル」「あじさいゼリー」の4つです。\n\n夏の季節限定料理にのみ出現する、新しいトモダチがいるようです。\n限定料理を購入して遊びに来てもらいましょう♪\n\n※夏の季節料理は\n『6月1日(火)〜8月31日(火)までの限定販売』となります。\n※販売期間を過ぎると、季節料理が変更されますのでご注意ください。',
      },
      {
        id: '21',
        type: 'info',
        name: 'おかずかんスピンオフノベルゲームへのリンクを追加！',
        date: '2021/05/14',
        detail:
          'Ver1.7.1にて、本アプリ内に「きざみのりみち」が主人公の短編ノベルゲーム『きざみのりみち ナンバーワンホストの道』のリンクを追加いたしました。\n『メニュー』→『オプション』→『シリーズ』からバナーリンクをタップすると、各ストアに移動し、スピンオフのゲームをダウンロードすることができます。\nぜひダウンロードしてプレイしてみてください♪ ',
      },
      {
        id: '20',
        type: 'release',
        name: 'おかずかんのスピンオフノベルゲームをリリースしました！',
        date: '2021/04/22',
        detail:
          '4月22日(金)より、おかずかんに登場するキャラクター「きざみのりみち」が主人公の短編ノベルゲーム『きざみのりみち ナンバーワンホストの道』をリリースしました！\n---------------------------------------\n『きざみのりみち ナンバーワンホストの道』は、選択肢を選ぶと物語が進んでいく選択式ノベルゲームで、「おかずかん」に登場する4キャラクターが繰り広げる物語となっています。\n\nナンバーワンホストを目指すのりみちの前に突如現れるPP会社の女社長こしょうふじん…\nあなたの選択次第で、のりみちの運命が決まるかも…？\n\nのりみちや、他のキャラクターの過去の話に加え、ここでしか見られないストーリーも！\n立ち絵は新規描き下ろしで表情豊かになっています♪\nぜひインストールしてプレイしてみてください！',
      },
      {
        id: '19',
        type: 'info',
        name: 'Ver1.7.0\n機能追加について',
        date: '2021/04/19',
        detail:
          'Ver1.7.0にて、新機能の実装を行いました。\n---------------------------------------\n■追加機能\n・料理一括設置機能\n\n同じ料理をテーブルに置ける全ての箇所に、まとめて置けるようになりました。\n\n「せっち」から料理を選択した後、「全部置く」ボタンを押すと、選択中の料理を空いている箇所全てに置きます。\n\nもう一度押すと、元の選択状態に戻します。',
      },
      {
        id: '18',
        type: 'info',
        name: 'Ver1.7.0\n家具を追加しました！',
        date: '2021/04/19',
        detail:
          '4月19日14時頃より、\nVer1.7.0にアップデートいたしました。\n\n■追加内容\n・新家具を2セット追加\n---------------------------------------\nVer1.7.0にて、家具が新しく2セット追加されました！\n今回追加された家具は、「ジャングルの部屋」「カクカクの部屋」の2つです。\n\n【ジャングルの部屋】\n熱帯雨林のような草木が生い茂るお部屋です♪\n天然素材にこだわりました！\n\n【カクカクの部屋】\nなにもかもがカクカクしているお部屋！\nちょっとクールな雰囲気です。\n新生活のはじまりとともに\n家具も新しくしちゃいましょう！',
      },
      {
        id: '17',
        type: 'info',
        name: 'Ver1.6.1\n不具合修正について',
        date: '2021/03/10',
        detail:
          '以下家具の一部に表示が崩れている箇所があったため、Ver1.6.1のアップデートにて修正いたしました。\n\n・どんぐりのカーテン\n・ラーメンカーテン\n\n本件につきまして、ご迷惑をおかけしましたことをお詫び申し上げます。',
      },
      {
        id: '16',
        type: 'info',
        name: 'Ver1.6.0\n不具合修正について',
        date: '2021/02/24',
        detail:
          '一部のAndroid端末にて、メニューの表示が崩れて操作が出来なくなってしまう不具合が生じておりましたが、Ver1.6.0のアップデートで修正を行いました。\n\n本件につきまして、ご迷惑をおかけしましたことをお詫び申し上げます。',
      },
      {
        id: '15',
        type: 'info',
        name: 'Ver1.6.0\n機能追加について',
        date: '2021/02/24',
        detail:
          'Ver1.6.0にて、新機能の実装を行いました。\n---------------------------------------\n■追加機能\n①プッシュ通知機能(iOSのみ)\niOSにおいて、以下のお知らせを通知出来るようになりました。\n・設置していた料理が全てなくなった時\n・新しいバージョンがリリースされた時\n\n通知のON/OFFは端末の設定より変更できます。\n【通知設定の変更方法】\n『設定』→『おかずかん』から通知許可を変更する。\n\n※Androidではプッシュ通知をご利用いただけません。\n誠に恐れ入りますが予めご了承ください。\n\n②新しいトモダチおよび料理へのジャンプ機能\n新たに出会ったトモダチや購入した料理が図鑑に登録された際\nずかん画面の左下に表示される看板をタップすると、\nまだ図鑑で確認していないトモダチや料理をすぐに確認できます。',
      },
      {
        id: '14',
        type: 'info',
        name: 'Ver1.6.0\n家具・料理追加のお知らせ',
        date: '2021/02/24',
        detail:
          '2月24日15時頃より、\nVer1.6.0にアップデートいたしました。\n\n■追加内容\n・新家具を2セット追加\n・季節限定料理を4点追加\n・新キャラクターの追加\n---------------------------------------\nVer1.6.0にて、家具が新しく2セット追加されました！\n今回追加された家具は、「ラーメンの部屋」「どんぐりの部屋」の2つです。\n\n【ラーメンの部屋】\nのれん風のカーテンで、\n昔ながらのラーメン屋さんになれちゃいます♪\n\n【どんぐりの部屋】\nおかずかんの案内役、どんぐりをイメージした家具です♪\nもしかしたらこんな部屋に住んでいるのかも…？\n\n家具を揃えて雰囲気を楽しんでみましょう！',
      },
      {
        name: 'Ver1.5.0\n機能追加や表示の変更について',
        type: 'info',
        date: '2020/12/18',
        id: '13',
        detail:
          'Ver1.5.0にて、新機能の実装や、表示の変更などを行いました。\n---------------------------------------\n■追加機能\n・フィルタ機能の実装\nショップの家具一覧を、絞り込んで表示できるようになりました。\nショップから「かぐ」を選択した時、下部に「フィルタ」ボタンが表示されます。\n「フィルタ」は、買えるスプーンの種類と、家具の種類の中から見たい家具のカテゴリーだけを選択し、絞り込んで表示させる事ができます。\n※選択をすべて外した状態では、「はい」は押せません。\n\n---------------------------------------\n■表示変更\n・スプーンドロップ時の表示方法変更\nトモダチが落としたスプーンを、吹き出しの中に表示されるように変更しました。\n吹き出しの表示場所はテーブルの上部になります。\nタップすると、以前と同様にスプーンを入手できます。',
      },
      {
        name: 'Ver1.5.0\n家具を追加しました！',
        type: 'info',
        date: '2020/12/18',
        id: '12',
        detail:
          '12月18日14時頃より、\nVer1.5.0にアップデートいたしました。\n\n■追加内容\n・新家具を2セット追加\n---------------------------------------\n今回は金スプーンで入手できる「ケーキの部屋」と、銀スプーンで入手できる「和室セット」を新しく追加しました！\n\n【ケーキの部屋 こだわりポイント】\nテーブルにはホイップをイメージしたクロスをかけています♪\n床に敷いているラグは、どこかで見た事があるデザイン…？\n\n【和室 こだわりポイント】\nどこか懐かしさを感じる振り子時計や、い草が香る新品の畳…つい寝転がってしまいます…\n※カーテンカテゴリーの「しょうじ」は、右側のみ開きます。\n\n好みのお部屋に変身させちゃいましょう！',
      },
      {
        name: 'Ver1.4.2\n機能追加や調整等について',
        type: 'info',
        date: '2020/12/04',
        id: '11',
        detail:
          'Ver1.4.2にて、機能の追加や、調整などを行いました。\n---------------------------------------\n■iPad対応アプリの配信開始\niPadの表示に対応したアプリの配信を開始しました！\n\n■トモダチの調整\n通常料理には登場しないトモダチのカテゴリーを「おなじみ」から「げんてい」に変更しました。\n\n■アップデート通知の実装\nストアにアップデートがある状態でアプリを起動した際に、アップデートをポップアップでお知らせする機能を追加しました。\n\n■不具合修正\n図鑑のタブ切り替えで起きていた、軽微な不具合を修正しました。',
      },
      {
        name: 'Ver1.4.1\n機能追加について',
        type: 'info',
        date: '2020/11/24',
        id: '10',
        detail:
          'Ver1.4.1にて、機能の追加を行いました。\n---------------------------------------\n■追加機能\n・ショップに季節限定料理の販売期間を明記しました\n・料理の設置時、通常と期間限定料理を別々に表示するようにしました',
      },
      {
        name: 'Ver1.4.0\n機能追加や表示調整について',
        type: 'info',
        date: '2020/11/19',
        id: '9',
        detail:
          'Ver1.4.0にて、機能の追加や、表示調整などを行いました。\n---------------------------------------\n■追加機能\n・料理の設置時に、料理の残り時間を選択できるようになりました\n・プレイ画面の背景に、アニメーションを追加しました\n---------------------------------------\n■変更機能\n・設置された料理は、残り時間以内に他の料理に置き換えできなくなりました\n（料理を消化した後に、新しい料理が設置できるようになります）\n---------------------------------------\n■細かい調整\n・「ふつうの時計」の色合いを調整しました',
      },
      {
        name: 'Ver1.4.0\n料理・家具を追加しました！',
        type: 'info',
        date: '2020/11/19',
        id: '8',
        detail:
          '11月19日14時頃より、\nVer1.4.0にアップデートいたしました。\n\n■追加内容\n・新家具を3セット追加\n・新キャラクターの追加\n---------------------------------------\n今回追加された家具は、金スプーンで入手できる「アボカドの部屋」「オムライスの部屋」と、銀スプーンで入手できる「落ち着いた部屋」の3つです！\n家具を揃えて、模様替えを楽しんでみてください♪\n\nさらに、新しいトモダチが増えました！\n今まで販売した料理の一部から登場することがあるようです。\nどの料理に出てくるのか、色んな料理を設置して試してみましょう♪',
      },
      {
        name: 'Ver1.3.0\n料理・家具を追加しました！',
        type: 'info',
        date: '2020/10/23',
        id: '7',
        detail:
          '10月23日14時頃より、\nVer1.3.0にアップデートいたしました。\n\n■追加内容\n・料理を5点追加\n・新キャラクターの追加\n・新家具を1セット追加\n---------------------------------------\n今回より『季節料理』が新しく追加されました！\n今回入手できる秋の季節料理は、\n「松茸の炭火焼き」「カツオのわら焼き」「かぼちゃグラタン」「運動会弁当」の4つです。\n\nどうやら、季節料理にしか出現しないトモダチもいるようです…！\nぜひ見つけてみてください♪\n\n※秋の季節料理は『10月23日〜11月30日までの限定販売』となります。\n\n※販売期間を過ぎると、季節料理が変更されますのでご注意ください。\n\nまた、ミッション報酬に「ショートケーキ」を追加しています。\nミッションをクリアして、ケーキを食べつつ一休みしましょう♪\n\nさらに、\n「かぼちゃの部屋」の家具セットを追加しました！\nかぼちゃの部屋の家具は、それぞれ金スプーンで購入できます。',
      },
      {
        name: '不具合修正完了のお知らせ',
        type: 'info',
        date: '2020/9/22',
        id: '6',
        detail:
          '一部おしながきの報酬が受け取れない不具合が発生しておりましたが、\nver１.2.1のアップデートにより解消いたしました。\nお手数ではございますが、各ストアよりアプリを更新していただけますよう\nよろしくお願い申し上げます。\nお客様にはご不便、ご迷惑をおかけしましたことをお詫び申し上げます。\n',
      },
      {
        name: '現在発生している不具合について',
        type: 'info',
        date: '2020/9/19',
        id: '5',
        detail:
          '現在、一部おしながきの報酬が受け取れない不具合が発生しております。\n本件の対応が終了次第、ver1.2.1のアップデートを行います。\nお客様にはご迷惑をおかけしており、誠に申し訳ございません。',
      },
      {
        name: 'Ver1.2.0\n機能追加と表示の調整について',
        type: 'info',
        date: '2020/9/18',
        id: '4',
        detail:
          'Ver1.2.0にて、新機能の実装や、表示調整などを行いました。\n\n---------------------------------------\n■追加機能\n・メニュー内に、オプションボタンを追加しました\n　└オプション内には「おしらせ」「BGM」「ヘルプ」ボタンがあります。\n・アプリのヘルプを追加しました\n　└ゲームの操作方法や、アイテムの使用方法などのヘルプを実装しました。\n・動画視聴、シェアで入手できるスプーンの貯金機能\n　└動画視聴や、シェアで入手できるスプーンを貯金できるようになりました\n・公式Twitterへ移動するボタン\n　└メニューボタン左上に、おかずかん公式Twitterへ移動できるボタンを設置しました。\n\n---------------------------------------\n■変更機能\n・図鑑の並び順を調整しました\n・図鑑の料理画像をタップすると食後になるようにしました\n・図鑑内で今まで集めた料理と、トモダチの数を表示するようにしました\n・ショップのアイコン枠を調整しました\n・図鑑が全て埋まっている状態で、ヒントを見たときに表示される画像を調整しました\n\n---------------------------------------\n■不具合修正\n・iPhone・iPadで起きていた、BGMの不具合を修正しました\n・Androidタブレットで起きていた、画面表示の不具合を修正しました\n\n---------------------------------------\n\n今後とも、おかずかんを\nよろしくお願いいたします。\n\n',
      },
      {
        name: 'Ver1.2.0\n料理・家具を追加しました！',
        type: 'info',
        date: '2020/9/18',
        id: '3',
        detail:
          '9月18日10時頃より、\nVer1.2.0にアップデートいたしました。\n\n■追加内容\n・料理を8点追加\n・新キャラクターの追加\n・新家具を2セット追加\n---------------------------------------\n今回は、\n「たこやき」「エビフライ」「ざるそば」「ふなもり」\nのほか、ミッション報酬に\n「まっちゃあんみつ」「バナナパフェ」\nの2点が追加されました。\n追加された料理には、新しいトモダチが\n登場することがありますので\nぜひチェックしてみてください♪\n\nさらに、超高級料理の\n「ごくあつステーキ」「フルーツもり」\nが登場です！\nたくさんスプーンを集めて\nGETしましょう♪\n\nまた、\n「トマトの部屋」「きのこの部屋」\nの家具セットを追加しました！\n2つの部屋の家具は、それぞれ\n金スプーンで購入できます。\n---------------------------------------\n今後とも、おかずかんを\nよろしくお願いいたします。\n\n',
      },
      {
        name: 'Ver1.1.0\n料理を追加しました！',
        type: 'info',
        date: '2020/8/21',
        id: '2',
        detail:
          '8月21日10時頃より、Ver1.1.0にアップデートいたしました。\n\n■アップデート内容\n・料理を2点追加\n・新キャラクターの追加\n---------------------------------------\n新しく追加した料理は、\n「餃子」「ミートソース(スパゲティ)」です♪\n新しいトモダチに会えるでしょうか…？\nぜひプレイして確かめてみてください！\n\n今後とも、おかずかんを\nよろしくお願いいたします。\n\n',
      },
      {
        name: '『おかずかん』配信開始しました',
        type: 'release',
        date: '2020/8/14',
        id: '1',
        detail:
          '本日より、「おかずかん」の配信を開始いたしました。\n\n『おかずかん』は料理をテーブルに設置しておくと、ちょっと不思議なキャラクターたちが遊びに来る放置型ゲームです。\n\n出会えたキャラクターは図鑑に追記され、キャラクターの詳しい情報を見ることができます。\n\nキャラクターは時間が経つと、スプーンを落として去っていきますが、まれに金のスプーンを落としていくことがあります。\n\nスプーンを使って、料理や家具を揃えましょう♪\n\nまた、キャラクターをタップすることで変わったアクションをすることがあります。\nもしかしたら意外な一面が見られるかもしれません…！\nぜひチェックしてみてください♪\n\n料理やキャラクターは、バージョンアップでどんどん追加していく予定です！\n\n今後とも、おかずかんを\nよろしくお願いいたします。\n\n',
      },
    ],
  },
  actions: {},
  mutations: {},
};
